import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/useryy/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/useryy/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/useryy/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/useryy/submit',
    method: 'post',
    data: row
  })
}

export const enAble = (data) => {
  return request({
    url: '/user/useryy/enAble',
    method: 'post',
    data: data
  })
}
